const t = {
  name: "Ethernet",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.9998 16V18H8.99977V16H14.9998Z" fill="currentColor"/>
<path d="M0.00976562 2H23.9998V15C23.9998 16.6523 22.6521 18 20.9998 18H18.6197L17.4554 20.3447L17.4542 20.3472C16.9463 21.363 15.9119 22.01 14.7698 22.01H9.23977C8.09768 22.01 7.06324 21.363 6.55534 20.3472L6.55411 20.3447L5.38982 18H3.00977C1.35748 18 0.00976562 16.6523 0.00976562 15V2ZM12.9998 4V9H10.9998V4H7.99977V9H5.99977V4H2.00977V15C2.00977 15.5477 2.46205 16 3.00977 16H6.62971L8.34419 19.4528C8.51643 19.7965 8.86216 20.01 9.23977 20.01H14.7698C15.1473 20.01 15.4925 19.7974 15.6648 19.4539L15.6653 19.4528L17.3798 16H20.9998C21.5475 16 21.9998 15.5477 21.9998 15V4H17.9998V9H15.9998V4H12.9998Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Ethernet
};
